export default function () {
  this.route("admin-invite", { path: "/u/admin-invite/:token" });
}
